export function isJpg(url: string): boolean {
  return (
    url.toLowerCase().endsWith('.jpg') || url.toLowerCase().endsWith('.jpeg')
  );
}

export function isPng(url: string): boolean {
  return url.toLowerCase().endsWith('.png');
}

/**
 * Helper function to ensure image URLs are optimized if they are coming from Contentful.
 * In this case it converts URLs starting with `//` to `https://`, checks the original format and if it is jpg or png, it will try to
 * convert it to webp format.
 * @param url
 * @returns
 */
export function optimizeImageUrl(url: string | undefined): string {
  if (!url) return '';

  const CONTENTFUL_HOST = 'images.ctfassets.net';
  const QUALITY = 'q';
  const QUALITY_VALUE = '80';
  const FORMAT = 'fm';
  const FORMAT_DEFAULT = 'webp';

  if (url.includes(CONTENTFUL_HOST)) {
    const urlWithProtocol = url.startsWith('//') ? `https:${url}` : url;
    const urlObj = new URL(urlWithProtocol);

    // Convert jpg or png to webp if possible via query parameters
    if (isJpg(urlObj.pathname) || isPng(urlObj.pathname)) {
      urlObj.searchParams.set(FORMAT, FORMAT_DEFAULT);
    }
    // Scale down quality on jpgs, but not on PNGs
    if (isJpg(urlObj.pathname) && !urlObj.searchParams.has(QUALITY)) {
      urlObj.searchParams.set(QUALITY, QUALITY_VALUE);
    }

    return urlObj.toString();
  }

  return url;
}
